import { STUFF_DETAIL } from "@/routes";
import { getEventDisplayDates, getEventRelativeDate } from "@/utils/eventDateUtils";
import { isEventEntity } from "@/utils/entityTypeDetector";

/** The reminder an entity offers, worded for an event or anything else. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function entityReminderPayload(entity: any, entityId: string) {
  const name = entity?.name || entity?.entity_name;
  const isEvent = isEventEntity(entity);
  const eventDates = isEvent ? getEventDisplayDates(entity) : null;
  const relativeLabel = (eventDates ? getEventRelativeDate(entity) : null) || "soon";

  return {
    title: name || (isEvent ? "Event" : "Reminder"),
    body: isEvent
      ? eventDates?.allDay
        ? `Happening ${relativeLabel}.`
        : `Starts ${relativeLabel}.`
      : `Check out ${name || "Untitled"}.`,
    deep_link: STUFF_DETAIL({ entityId }),
    data: { entity_id: entityId, kind: isEvent ? "event_reminder" : "entity_reminder" },
  };
}
